import { apiGet, apiPost } from '@/services/api/apiClient';
import { API_ENDPOINTS } from '@/constants/endpoints';
import { LoginRequest, LoginResponse, ProfileResponse } from '@/constants/types';

class AuthService {
  async login(loginData: LoginRequest): Promise<LoginResponse> {
    try {
      const response = await apiPost<LoginResponse>(
        API_ENDPOINTS.AUTH.LOGIN,
        loginData,
        { showLoader: true, backdrop: false }
      );
      return response;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Login failed');
    }
  }

  async getProfile(): Promise<ProfileResponse> {
    try {
      const response = await apiGet<ProfileResponse>(
        API_ENDPOINTS.AUTH.PROFILE+'?type=2',
        { showLoader: true }
      );
      return response;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Failed to fetch profile');
    }
  }

  async logout(): Promise<void> {
    try {
      await apiPost(API_ENDPOINTS.AUTH.LOGOUT);
    } catch (error: any) {
      console.error('Logout error:', error);
    }
  }

  async refreshToken(): Promise<LoginResponse> {
    try {
      const response = await apiPost<LoginResponse>(
        API_ENDPOINTS.AUTH.REFRESH_TOKEN,
        {},
        { showLoader: false }
      );
      return response;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Token refresh failed');
    }
  }
}

export const authService = new AuthService();